import { render, staticRenderFns } from "./GraficoVendasMensal.vue?vue&type=template&id=0b8354ad&"
import script from "./GraficoVendasMensal.vue?vue&type=script&lang=js&"
export * from "./GraficoVendasMensal.vue?vue&type=script&lang=js&"
import style0 from "./GraficoVendasMensal.vue?vue&type=style&index=0&id=0b8354ad&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports